import React, { useState } from "react";
import DemoModal    from "./Demomodal";     // adjust path if needed
import ContactModal from "./Contactmodal";  // adjust path if needed

const CTASection = () => {
  const [demoOpen,    setDemoOpen]    = useState(false);
  const [contactOpen, setContactOpen] = useState(false);

  return (
    <>
      <section
        id="contact"
        className="bg-gradient-to-br from-blue-600 via-blue-700 to-indigo-800 py-24 text-center text-white relative overflow-hidden"
      >
        {/* Background decoration */}
        <div className="absolute top-0 left-0 w-96 h-96 bg-white/5 rounded-full -translate-x-1/2 -translate-y-1/2 pointer-events-none" />
        <div className="absolute bottom-0 right-0 w-96 h-96 bg-white/5 rounded-full translate-x-1/2 translate-y-1/2 pointer-events-none" />

        <div className="relative max-w-4xl mx-auto px-6">
          <div className="inline-block bg-white/20 text-white px-4 py-2 rounded-full text-sm font-medium mb-8">
            Get Started Today
          </div>

          <h2 className="text-4xl md:text-5xl font-bold leading-tight">
            Ready to Meet EU DPP Compliance?
          </h2>

          <p className="text-lg text-blue-100 mt-6 max-w-2xl mx-auto leading-relaxed">
            Our experts are here to advise. Start building secure digital product passports
            today and stay ahead of regulatory requirements.
          </p>

          <div className="flex justify-center gap-4 mt-10 flex-wrap">
            {/* Opens DemoModal — pre-selected on "Request Demo" tab */}
            <button
              onClick={() => setDemoOpen(true)}
              className="bg-white text-blue-700 font-semibold px-8 py-4 rounded-xl shadow-lg hover:bg-gray-50 hover:-translate-y-1 hover:shadow-xl transition-all duration-200 will-change-transform"
            >
              Request a Demo →
            </button>

            {/* Opens ContactModal */}
            <button
              onClick={() => setContactOpen(true)}
              className="border-2 border-white/60 text-white px-8 py-4 rounded-xl font-semibold hover:bg-white hover:text-blue-700 hover:border-white hover:-translate-y-1 hover:shadow-xl transition-all duration-200 will-change-transform"
            >
              Connect With Us
            </button>
          </div>
        </div>
      </section>

      {/* Modals */}
      {demoOpen    && <DemoModal    initialTab={0} onClose={() => setDemoOpen(false)} />}
      {contactOpen && <ContactModal              onClose={() => setContactOpen(false)} />}
    </>
  );
};

export default CTASection;